import { render, staticRenderFns } from "./bg.vue?vue&type=template&id=3f129ea8&scoped=true"
import script from "./bg.vue?vue&type=script&lang=js"
export * from "./bg.vue?vue&type=script&lang=js"
import style0 from "./bg.vue?vue&type=style&index=0&id=3f129ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f129ea8",
  null
  
)

export default component.exports